import React from 'react';
import Modal from '../../../BaseComponents/Modal';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
type Props = {
  isOpen: boolean;
  onClose: () => void;

};

const ViewFood = ({ isOpen, onClose }: Props) => {
  const { foodToView } = useSelector(
    (state: RootState) => state.foods
  );
  console.log('foodToView', foodToView);
  return (
    <Modal isOpen={isOpen} onClose={onClose} 
    title={'Food'}
    width={'800px'}>

      <div className='food-modal-form'>
        <div>
          <img alt={foodToView?.name}
           src={foodToView?.image_url ?? ''}
           width={'100'} height={'100'} />
        </div>
        <h3>{foodToView?.name}</h3>
          <p>{foodToView?.description}</p>
      </div>
    </Modal>
  );
};

export default ViewFood;
